module.exports = __webpack_public_path__ + "assets/img/canimmunize-logo-white-c6c8060b328c84e0955c0dff15c5ae63.png";